<script setup>
import { inject, ref } from 'vue';
import MeasureLayerManager from './MeasureLayerManager';

defineProps({
  options: {
    type: Object,
    default: () => {
      return {}
    }
  }
});

const emit = defineEmits(['isActive']);

const isActive = ref(false);
const measureLayer = ref(null);

const $map = inject('$map');

const toggleMeasure = () => {
  if (isActive.value) {
    measureLayer.value.clear();
    $map.removeLayer(measureLayer.value);
    measureLayer.value = null;
    isActive.value = false;
    emit('isActive', false);
  } else {
    measureLayer.value = new MeasureLayerManager($map);
    measureLayer.value.setMode('Line');
    $map.addLayer(measureLayer.value);
    isActive.value = true;
    emit('isActive', true);
  }
}

defineExpose({
  toggleMeasure
})
</script>

<template>
  <button :class="{ active: isActive }" @click="toggleMeasure">
    <i :class="options.icon" />
  </button>
</template>